import { useContext } from 'react';

import { ToastContext } from 'context/toast-context/ToastContext';

const useToast = () => {
	const context = useContext(ToastContext);
	if (!context) {
		throw new Error('useToast must be used within a ToastProvider');
	}
	return context;
};

export default useToast;
